import { render, staticRenderFns } from "./Postmark.vue?vue&type=template&id=7753b64a&scoped=true"
import script from "./Postmark.vue?vue&type=script&lang=js"
export * from "./Postmark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7753b64a",
  null
  
)

export default component.exports